import CommonNaviBar from '../../common/component/NaviBar'

class NaviBar extends CommonNaviBar {
  constructor (props) {
    super(props)
    this.userRole = 'companyAdmin'
    this.userRoleUrl = 'company_admin'
    this.naviSetting = [
      {
        dropdownToggle: 'マイページ',
        dropdownMenu: [
          {
            title: 'Home',
            url: '/company_admin'
          },
          {
            title: 'お知らせ',
            url: '/company_admin/information'
          },
          {
            title: '共有ファイル',
            url: '/company_admin/shared_files'
          }
        ]
      },
      {
        dropdownToggle: '日常業務',
        dropdownMenu: [
          {
            title: '企業管理',
            url: '/company_admin/company/detail'
          },
          {
            title: 'ユーザ管理',
            url: '/company_admin/company_user'
          }
        ]
      },
      {
        dropdownToggle: '個人設定',
        dropdownMenu: [
          {
            title: 'パスワード変更',
            url: '/company_admin/password_change'
          },
          {
            title: 'メールアドレス変更',
            url: '/company_admin/email_change'
          },
          {
            title: '通知受信可否設定変更',
            url: '/company_admin/notification_setting_change'
          }
        ]
      },
      {
        dropdownToggle: 'アンケート',
        dropdownMenu: [
          {
            title: 'アンケート回答',
            url: '/company_admin/survey_answer'
          }
        ]
      },
    ]
  }
}

export default NaviBar



// WEBPACK FOOTER //
// ./src/company_admin/components/NaviBar.js